import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Data, AppService } from '../../app.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  total = [];
  subTotal=[];
  cgst=[];
  grandSubTotal=[];
  grandSubTotalFinal=0;
  gstTotal=0;
  grandTotal = 0;
  cartItemCount = [];
  cartItemCountTotal = 0;
  constructor(public appService: AppService,
   public router: Router ) { }

  ngOnInit() {
    //this.cartDataLoad();
   debugger;
    this.appService.Data.cartList.forEach(product => {  
      debugger;   
      this.subTotal[product.productId] = product.cartCount * product.productPrice;
      this.total[product.productId] = this.subTotal[product.productId] + (this.subTotal[product.productId])*product.cgst/100;
      this.cartItemCount[product.productId] = product.cartCount;
      this.cartItemCountTotal += product.cartCount;
      this.grandSubTotalFinal+=this.subTotal[product.productId];      
      this.gstTotal+=(this.subTotal[product.productId])*product.cgst/100;
      this.grandTotal += this.total[product.productId];
    });

    
  }

  public cartDataLoad() {
    this.appService.getLoadCartItems('/api/Cart').subscribe(data => {
    debugger;
      this.appService.Data.cartList.push(data);
    },
      error => {
        console.log(error.error.errors);
      })
  }

  public updateCart(value) {  
    if (value) { 
    
      this.subTotal[value.productId]=value.subTotal;
      this.cgst[value.productId]=value.cgst;
      this.total[value.productId] = value.total;
      this.grandSubTotal=value.subTotal;     
      this.cartItemCount[value.productId] = value.soldQuantity;
      this.grandSubTotalFinal=0;
      this.gstTotal=0;
      this.grandTotal = 0;
      this.subTotal.forEach(price => {       
      this.grandSubTotalFinal+=price;     
        
      });    
      
      
      this.total.forEach(price => {
        this.grandTotal += price;        
      });

      this.appService.Data.cartList.forEach(product => {      
           debugger
        this.gstTotal+=(this.subTotal[product.productId])*product.cgst/100;
      
      });

     
      this.cartItemCountTotal = 0;
      this.cartItemCount.forEach(count => {
        this.cartItemCountTotal += count;
      });

      this.appService.Data.totalPrice = this.grandTotal;
      this.appService.Data.totalCartCount = this.cartItemCountTotal;

      this.appService.Data.cartList.forEach(product => {
        this.cartItemCount.forEach((count, index) => {
          if (product.productId == index) {
            product.cartCount = count;
            product.loggedUserId = 3;
            this.appService.updateCartItem("api/Cart", product).subscribe(data => {
              console.log("cart updated");
            },
              error => {
                console.log(error.error.errors);
              })
          }
        });
      });

    }
  }

  public remove(product) {
    debugger;

    const index: number = this.appService.Data.cartList.indexOf(product);
    if (index !== -1) {
      debugger;
      this.appService.Data.cartList.splice(index, 1);
      this.grandTotal = this.grandTotal - this.total[product.productId];
      this.grandSubTotalFinal=this.grandSubTotalFinal-this.subTotal[product.productId];
      this.appService.Data.totalPrice = this.grandTotal;      

      this.total.forEach(val => {
        if (val == this.total[product.id]) {
          this.total[product.id] = 0;
        }
      });
      this.appService.Data.cartList.forEach(product => {    
          this.gstTotal=(this.subTotal[product.productId])*product.cgst/100;
   
   });

      this.cartItemCountTotal = this.cartItemCountTotal - this.cartItemCount[product.id];
      this.appService.Data.totalCartCount = this.cartItemCountTotal;
      this.cartItemCount.forEach(val => {
        if (val == this.cartItemCount[product.id]) {
          this.cartItemCount[product.id] = 0;
        }
      });
      this.appService.resetProductCartCount(product);
     
    }
  }

  public clear() {
    this.appService.Data.cartList.forEach(product => {
      this.appService.resetProductCartCount(product);
    });
    this.appService.Data.cartList.length = 0;
    this.appService.Data.totalPrice = 0;
    this.appService.Data.totalCartCount = 0;
  }

}
